import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { PageNotfoundComponent } from './component/page-notfound/page-notfound.component';
import { HomeComponent } from './component/home/home.component';
import { CommonModule } from '@angular/common';
import { TwodLiveComponent } from './component/twod-live/twod-live.component';

const routes: Routes = [
    {
      path: '', 
      redirectTo: 'home',
      pathMatch: 'full'
    },    
    {
      path: 'home', component: HomeComponent,
    },
    {
      path: 'home/:deviceId', component: HomeComponent,
    },
    {
      path: 'home/:deviceId/:fcmToken', component: HomeComponent,
    },     
    {
      path: 'twod-live', component: TwodLiveComponent
    },  
    {
      path: '**', component: PageNotfoundComponent
    }     
    
];

@NgModule({
  imports: [CommonModule,RouterModule.forRoot(routes, {onSameUrlNavigation: 'reload'})],
  exports: [RouterModule]
})
export class AppRoutingModule { }